import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactRedux from 'react-redux';
import store from 'store';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import {
  getOptimizelyClient,
  getOptimizelyUserAttributes,
  getOrCreateOptimizelyUserIdCookie,
} from 'lib/optimizely';

export default function withInit(WrappedComponent, provideStore = false) {
  class WrappedComponentWithInit extends React.Component {
    static init(id, props) {
      try {
        ReactDOM.render(
          <WrappedComponentWithInit {...props} />,
          document.getElementById(id),
        );
      } catch (e) {
        // If the render fails, the normal error is pretty vague as to which component failed.
        // eslint-disable-next-line no-console
        console.error(`Cannot render ${WrappedComponent.name} to #${id}:`, e);
      }
    }

    render() {
      return (
        <OptimizelyProvider
          optimizely={getOptimizelyClient()}
          user={{
            attributes: getOptimizelyUserAttributes(),
            id: getOrCreateOptimizelyUserIdCookie(),
          }}
        >
          {provideStore ? (
            <ReactRedux.Provider store={store}>
              <WrappedComponent {...this.props} />
            </ReactRedux.Provider>
          ) : (
            <WrappedComponent {...this.props} />
          )}
        </OptimizelyProvider>
      );
    }
  }

  return WrappedComponentWithInit;
}



// WEBPACK FOOTER //
// ./src-react/WithInit/index.jsx